import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

export enum NoteKeyActions
{
    EscAction = 'escAction',
    TabAction = 'tabAction',
    EnterAction = 'enterAction',
}

export const NoteKeyMapConfig = {
    [NoteKeyActions.EscAction]: 'esc',
    [NoteKeyActions.TabAction]: ['tab', 'shift+tab'],
    [NoteKeyActions.EnterAction]: ['shift+enter'],
};

export class MeshNoteKeyboardHandlers
{
    public static getHandlers(ctx:IWSPMeshContext)
    {
        return {
            [NoteKeyActions.EnterAction]: (event:KeyboardEvent) =>
            {
                // const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
                // const noteState = meshState.note;

                // const {meshNote} = controllers.ui.spreadsheets;
                // meshNote.applyNotes(ctx);

                if( event.shiftKey )
                {
                    controllers.ui.spreadsheets.mesh.finishEditingNote(ctx);

                    event.stopPropagation();
                    event.preventDefault();
                }
            },
            [NoteKeyActions.EscAction]: (event:KeyboardEvent) =>
            {
                // const {meshNote} = controllers.ui.spreadsheets;

                controllers.ui.spreadsheets.mesh.finishEditingNote(ctx);

                event.stopPropagation();
                event.preventDefault();
            },
            [NoteKeyActions.TabAction]: (event:KeyboardEvent) =>
            {
                const fromElement:Element = event.srcElement;

                controllers.ui.spreadsheets.meshNote.nextFieldByTab(ctx, fromElement);

                event.stopPropagation();
                event.preventDefault();
            },
        };
    }
}
